import React from "react";
import { Link } from "@reach/router";
import noResultImg from "../../../../images/no-result.svg";
import "./scss/index.scss";

export const NoResult: React.FC<{}> = (): JSX.Element => {
  return (
    <div className="no-result card">
      <img className="no-result__img" src={noResultImg} alt="no-result" />
      <div className="no-result__info">Nie znaleziono wyszukiwanej frazy.</div>
      <Link to="/">
        <button className="button no-result__button">
          zobacz wszystkie posty
        </button>
      </Link>
    </div>
  );
};
